import React, { useState } from "react";
import { Form, Table } from "react-bootstrap";
import Pagination from "../../ETMF/Pagination/Pagination";
import Moment from "react-moment";
import { elearningServices } from "../../../Services/elearningServices";
import Swal from "sweetalert2";

const ELearningDataTable = ({
  handleRowClick,
  handleAddNewTab,
  elearningData,
  getStudyELearningData,
  handleUpdate,
  viewTypeData,
  trainingId,
  onMouseDown,
  tableRef
}) => {
  const deleteStudyELearningData = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete Data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let data = await elearningServices.deleteStudyELearningData(id);
        if (data?.statusCode === 200) {
          getStudyELearningData();
        }
      }
    });
  };

  const updateStudyELearningStatus = async (id, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Data Status!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let data = {};
        data.id = id;
        data.status = status;
        let results = await elearningServices.updateStudyELearningStatus(data);
        if (results?.statusCode === 200) {
          getStudyELearningData();
        }
      }
    });
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const result = elearningData?.slice(startIndex, endIndex);
  const totalPage = Math.ceil(elearningData?.length / itemsPerPage);

  return (
    <>
      <Table
        id="resizable-table"
        striped
        hover
        className="m-0 custom-table"
        ref={tableRef}
      >
        <thead className="thead-sticky top-0">
          <tr>
            <th style={{ width: 45 }} onMouseDown={(e) => onMouseDown(e, 0)}>Sr.</th>
            <th onMouseDown={(e) => onMouseDown(e, 1)}>Training Name</th>
            <th onMouseDown={(e) => onMouseDown(e, 2)}>Description</th>
            <th>No. of completion days</th>
            {viewTypeData === "ctms" &&
              <th style={{ width: 80 }} onMouseDown={(e) => onMouseDown(e, 3)}>Status</th>
            }
            <th onMouseDown={(e) => onMouseDown(e, 4)}>Created Date | Time</th>
            <th onMouseDown={(e) => onMouseDown(e, 5)}>Modified Date | Time</th>
            {viewTypeData === "ctms" &&
              <th style={{ width: 50 }} className="text-center" onMouseDown={(e) => onMouseDown(e, 6)}>
                Edit
              </th>
            }
            <th style={{ width: 50 }} className="text-center" onMouseDown={(e) => onMouseDown(e, 7)}>
              View
            </th>
            {viewTypeData === "ctms" &&
              <th style={{ width: 50 }} className="text-center" onMouseDown={(e) => onMouseDown(e, 8)}>
                Delete
              </th>
            }
          </tr>
        </thead>
        <tbody>
          {result?.map((item, index) => (
            <tr key={index} className={`CP ${trainingId === item?._id ? "highlighted" : ""}`}>
              <td onClick={() => handleRowClick(item?._id)}>{index + 1}</td>
              <td onClick={() => handleRowClick(item?._id)}>{item.name}</td>
              <td title={item.description} onClick={() => handleRowClick(item?._id)}>{item.description}</td>
              <td onClick={() => handleRowClick(item?._id)}>{item.completionDays}</td>
              {viewTypeData === "ctms" &&
                <td onClick={() => handleRowClick(item?._id)}>
                  <Form.Select
                    disabled={item?.checkAnswer}
                    title={item?.checkAnswer ? "Traning is already started so no any delete training" : "Edit"}
                    className={`border-0 p-0 rounded-0 bg-transparent ${item.status.toLowerCase()}`}
                    value={item.status}
                    onChange={(e) =>
                      updateStudyELearningStatus(item?.id, e.target.value)
                    }
                  >
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </Form.Select>
                </td>
              }
              <td onClick={() => handleRowClick(item?._id)}>
                <Moment format="DD MMM YYYY | HH:mm">{item.createdAt}</Moment>
              </td>
              <td onClick={() => handleRowClick(item?._id)}>
                <Moment format="DD MMM YYYY | HH:mm">{item.updatedAt}</Moment>
              </td>
              {viewTypeData === "ctms" &&
                <td className="text-center">
                  <button
                    title={item?.checkAnswer ? "Traning is already started so no any update training" : "Edit"}
                    onClick={() => handleUpdate(item)}
                    className="text-white border-success bg-success border"
                    disabled={item?.checkAnswer}
                    style={{
                      fontSize: 10,
                      borderRadius: 3,
                      padding: "2px 8px",
                    }}
                  >
                    Edit
                  </button>
                </td>
              }
              <td className="text-center">
                <button
                  onClick={() =>
                    handleAddNewTab(
                      `${item.name}`,
                      "fa-solid fa-folder",
                      `trainingDataManagement_${item?._id}`,
                      { traningId: item?._id }
                    )
                  }
                  className="text-white border-success bg-success border"
                  style={{
                    fontSize: 10,
                    borderRadius: 3,
                    padding: "2px 8px",
                  }}
                >
                  View
                </button>
              </td>
              {viewTypeData === "ctms" &&
                <td className="text-center">
                  <button
                    disabled={item?.checkAnswer}
                    title={item?.checkAnswer ? "Traning is already started so no any delete training" : "Edit"}
                    onClick={() => deleteStudyELearningData(item?._id)}
                    className="text-white border-danger bg-danger border"
                    style={{
                      fontSize: 10,
                      borderRadius: 3,
                      padding: "2px 8px",
                    }}
                  >
                    Delete
                  </button>
                </td>
              }
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="position-sticky bottom-0">
        <Pagination
          totalPage={totalPage}
          pageNumber={pageNumber}
          itemsPerPage={itemsPerPage}
          totalItems={elearningData?.length}
          setPageNumber={setPageNumber}
          setItemsPerPage={setItemsPerPage}
        />
      </div>
    </>
  );
};

export default ELearningDataTable;
